import PropTypes from "prop-types";
import React, { Component } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import { withStyles } from "@material-ui/core/styles";
import { translator } from "../utils/i18n";
import Inscription from "./Inscription";
import { buildCgu, connexion, subscribe } from "../utils/fetcher";
import Connexion from "./Connexion";
import { connect } from "react-redux";
import AlertDialog from "./AlertDialog";
import { showBtnNext, showDialogSms } from "../actions";
import ConfirmationSms from "./subscribe/ConfirmationSms";
import { isLoggedIn } from "../utils/user";
import Alert from "@material-ui/lab/Alert";

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
});

class ConnexionInscription extends Component {
  state = {
    value: 0,
    showCgu: false
  };

  componentDidMount() {
    this.props.showBtnNext(true);
    this.props.isLoggedIn();
  }

  componentWillUnmount() {
    this.props.showBtnNext(false);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleSubmitFormInscription = values => {
    this.props.inscription(values);
  };

  handleSubmitFormConnexion = values => {
    values["token_rdv"] = "token";
    this.props.connexion(values);
  };

  showCguDialog = e => {
    e.preventDefault();
    this.props.buildCgu();
    this.setState({ showCgu: true });
  };

  onClickDialogCgu = () => {
    this.setState({ showCgu: false });
  };

  render() {
    const { value } = this.state;
    return (
      <React.Fragment>
        {this.state.showCgu && (
          <AlertDialog
            isHideTitle={true}
            content={this.props.cgu}
            onClick={this.onClickDialogCgu}
            isResetAlert={true}
          />
        )}

        <div className="connexion-inscription">
          {this.props.isRequiredSocialSeCurity && (
            <Alert severity="error">
              {translator()._("W_MESSAGE_SECURITE_SOCIALE")}
            </Alert>
          )}
          {this.props.isRequiredPayment && (
            <Alert severity="error">
              {translator()._("W_ALERT_CARTE_PAIEMENT")}
            </Alert>
          )}
          <AppBar position="static">
            <Tabs
              indicatorColor="primary"
              value={value}
              onChange={this.handleChange}
            >
              <Tab label={translator()._("W_STEP4_TITRE_MENU_INSCRIPTION")} />
              <Tab label={translator()._("W_STEP4_TITRE_MENU_ACCES_MEMBRE")} />
            </Tabs>
          </AppBar>
          {value === 0 && (
            <Inscription
              message={this.props.message}
              onSubmit={this.handleSubmitFormInscription}
              showCguDialog={this.showCguDialog}
              telDefault={this.props.telDefault}
            />
          )}
          {value === 1 && (
            <Connexion
              message={this.props.message}
              onSubmit={this.handleSubmitFormConnexion}
            />
          )}
        </div>
        {this.props.showDialogSms && (
          <ConfirmationSms codeSms={this.props.codeSms || ""} />
        )}
      </React.Fragment>
    );
  }
}

ConnexionInscription.propTypes = {
  buildCgu: PropTypes.func,
  cgu: PropTypes.any,
  codeSms: PropTypes.string,
  connexion: PropTypes.func,
  inscription: PropTypes.func,
  isLoggedIn: PropTypes.func,
  isRequiredPayment: PropTypes.any,
  isRequiredSocialSeCurity: PropTypes.any,
  message: PropTypes.any,
  showBtnNext: PropTypes.func,
  showDialogSms: PropTypes.any,
  telDefault: PropTypes.any
};

const mapStateToProps = state => {
  return {
    message: state.message,
    cgu: state.cgu,
    showDialogSms: state.showDialogSms,
    codeSms: state.codeSms,
    telDefault: state.configuration.teldefaut || "fr",
    isRequiredSocialSeCurity: state.configuration.baffsecu,
    isRequiredPayment: state.payment && state.payment.isRequired
  };
};

const mapDispatchToProps = dispatch => {
  return {
    inscription: values => dispatch(subscribe(values)),
    connexion: values => dispatch(connexion(values)),
    isLoggedIn: () => dispatch(isLoggedIn()),
    buildCgu: () => dispatch(buildCgu()),
    setDialogSms: () => dispatch(showDialogSms()),
    showBtnNext: isShow => dispatch(showBtnNext(isShow))
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConnexionInscription)
);
